import { render, staticRenderFns } from "./supervisorDetails.vue?vue&type=template&id=256f9989&scoped=true"
import script from "./supervisorDetails.vue?vue&type=script&lang=js"
export * from "./supervisorDetails.vue?vue&type=script&lang=js"
import style0 from "./supervisorDetails.vue?vue&type=style&index=0&id=256f9989&prod&lang=css"
import style1 from "./supervisorDetails.vue?vue&type=style&index=1&id=256f9989&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f9989",
  null
  
)

export default component.exports